// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__12yQD","tab":"ProcedureTabs_tab__1fpZy"};